import { render } from "./AddEditRole.vue?vue&type=template&id=be1d4dee"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__